import { cn } from "@/lib/utils";

const phaseStyles: Record<string, string> = {
  start: "bg-slate-500/10 text-slate-400 border-slate-500/20",
  dump: "bg-teal-500/10 text-teal-400 border-teal-500/20",
  transfer: "bg-blue-500/10 text-blue-400 border-blue-500/20",
  restore: "bg-green-500/10 text-green-400 border-green-500/20",
  inference: "bg-rose-400/10 text-rose-400 border-rose-400/20",
  machine: "bg-amber-500/10 text-amber-400 border-amber-500/20",
};

export function FailurePhaseBadge({ phase }: { phase: string }) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md border px-1.5 py-0.5 text-[10px] font-medium",
        phaseStyles[phase] ?? "bg-muted text-muted-foreground border-border",
      )}
    >
      {phase}
    </span>
  );
}
